import styled from '@emotion/styled';
import React from 'react';

import { animationFade } from '../../../../theme/animations/animationFade';
import { motion } from '../../../../theme/motion';

export function PairingView(props) {
  return <PairingView.Root>{props.children}</PairingView.Root>;
}

PairingView.Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  flex: 1 1 auto;
  animation: ${animationFade.in} ${motion.duration.slow} ease-out 1 forwards;
`;
